import BackgroundImageLoader from '@components/imageModules/backgroundImageLoader'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Ireq {
  title: string
  desc: string
}

interface Props {
  reqs: Ireq[]
  featuredImage?: IGatsbyImageDataObject
  imgContainerClasses?: string
  headlineClasses?: string
  bgImageClasses?: string
  contentContainerCss?: string
}

function ReqsHalfPage(props: Props) {
  const { reqs, featuredImage, imgContainerClasses, headlineClasses, bgImageClasses, contentContainerCss } = props

  return (
    <div className='et-grid-basic'>
      <div className={twMerge('relative col-start-2 overflow-hidden col-span-2 h-[300px] mb-8 md:col-start-2 md:col-span-12 lg:h-full lg:flex lg:col-start-2 lg:col-span-5 lg:-ml-8 xl:col-start-2 xl:col-span-6', imgContainerClasses)}>
        {featuredImage && <BackgroundImageLoader
          bgImageClasses={bgImageClasses}
          showBlurImage={true}
          gatsbyDataImg={featuredImage.gatsbyImageData} />}
      </div>
      <div className={twMerge('col-span-2 col-start-2 md:col-start-4 md:col-span-8 lg:px-8 lg:col-start-7 lg:col-span-7 xl:col-start-8 xl:col-span-6', contentContainerCss)} >
        <h2 className={twMerge('mb-8 section-h2 font-sentinel__SemiBoldItal lg:max-w-[400px] xl:mb-12 xl:max-w-[455px]', headlineClasses)}>
          Requirements for this course
        </h2>
        <ul>
          {reqs.map((req, index) => {
            return (
              <li
                className='mb-8 last:mb-0 [&>h3]:text-xl [&>h3]:font-bold [&>h3]:mb-2'
                key={index}
                dangerouslySetInnerHTML={{ __html: `${req.title} ${req.desc}` }}>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default ReqsHalfPage
